<template>
  <div v-if="purchaseOrder" class="main-content po-view-page">
    <div class="page-header">
      <h3 class="page-title"> {{ purchaseOrder.purchase_order_number }}</h3>
      <div class="page-actions row">
        <!-- <div class="col-xs-2 mr-3">
          <base-button
            v-if="purchaseOrder.status === 'DRAFT'"
            :loading="isMarkAsSent"
            :disabled="isMarkAsSent"
            :outline="true"
            color="theme"
            @click="onMarkAsSent"
          >
            {{ $t('pos.mark_as_sent') }}
          </base-button>
        </div> -->
        <div class="col-xs-2">
          <base-button
            v-if="purchaseOrder.status === 'DRAFT'"
            :loading="isSendingEmail"
            :disabled="isSendingEmail"
            color="theme"
            @click="onSendPurchaseOrder"
          >
            {{ $t('pos.send_po') }}
          </base-button>
        </div>
        <v-dropdown :close-on-select="false" align="left" class="filter-container" v-if="purchaseOrder.status=='DRAFT' && userType=='anchor'">
          <a slot="activator" href="#">
            <base-button color="theme">
              <font-awesome-icon icon="ellipsis-h" />
            </base-button>
          </a>
          <v-dropdown-item>
            <router-link :to="{path: `/anchor/purchase-orders/${$route.params.id}/edit`}" class="dropdown-item">
              <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon"/>
              {{ $t('general.edit') }}
            </router-link>
            <div class="dropdown-item" @click="removePurchaseOrder($route.params.id)">
              <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
              {{ $t('general.delete') }}
            </div>
          </v-dropdown-item>
        </v-dropdown>
      </div>
    </div>
    <div class="po-sidebar">
      <base-loader v-if="isSearching" />
      <div v-else class="side-header">
        <base-input
          v-model="searchData.searchText"
          :placeholder="$t('general.search')"
          input-class="inv-search"
          icon="search"
          type="text"
          align-icon="right"
          @input="onSearched()"
        />
        <div
          class="btn-group ml-3"
          role="group"
          aria-label="First group"
        >
          <v-dropdown :close-on-select="false" align="left" class="filter-container">
            <a slot="activator" href="#">
              <base-button class="inv-button inv-filter-fields-btn" color="default" size="medium">
                <font-awesome-icon icon="filter" />
              </base-button>
            </a>
            <div class="filter-title">
              {{ $t('general.sort_by') }}
            </div>
            <div class="filter-items">
              <input
                id="filter_purchase_order_date"
                v-model="searchData.orderByField"
                type="radio"
                name="filter"
                class="inv-radio"
                value="purchase_order_date"
                @change="onSearched"
              >
              <label class="inv-label" for="filter_purchase_order_date">{{ $t('reports.pos.po_date') }}</label>
            </div>
            <div class="filter-items">
              <input
                id="filter_due_date"
                v-model="searchData.orderByField"
                type="radio"
                name="filter"
                class="inv-radio"
                value="expiry_date"
                @change="onSearched"
              >
              <label class="inv-label" for="filter_due_date">{{ $t('pos.due_date') }}</label>
            </div>
            <div class="filter-items">
              <input
                id="filter_purchase_order_number"
                v-model="searchData.orderByField"
                type="radio"
                name="filter"
                class="inv-radio"
                value="purchase_order_number"
                @change="onSearched"
              >
              <label class="inv-label" for="filter_purchase_order_number">{{ $t('pos.po_number') }}</label>
            </div>
          </v-dropdown>
          <base-button v-tooltip.top-center="{ content: getOrderName }" class="inv-button inv-filter-sorting-btn" color="default" size="medium" @click="sortData">
            <font-awesome-icon v-if="getOrderBy" icon="sort-amount-up" />
            <font-awesome-icon v-else icon="sort-amount-down" />
          </base-button>
        </div>
      </div>
      <div class="side-content">
        <a
          v-for="(purchaseOrder,index) in purchaseOrders"
          :key="index"
          class="side-po"
          href="#/"
          @click="viewPurchaseOrder(purchaseOrder.id)"
        >
          <div class="left">
            <div class="inv-name" v-if="(userType=='anchor'|| userType=='super_admin')">
              <p v-if="purchaseOrder.supplier_stakeholder">
                <span v-if="purchaseOrder.supplier_stakeholder.details.company && purchaseOrder.supplier_stakeholder.details.company.name">
                  {{purchaseOrder.supplier_stakeholder.details.company.name }}
                </span>
                <!-- {{purchaseOrder.supplier_stakeholder.details.user.name }} -->
              </p>
            </div>
            <div class="inv-name" v-else-if="userType=='supplier'">
              <p v-if="purchaseOrder.buyer_stakeholder">
                <span v-if="purchaseOrder.buyer_stakeholder.details.company && purchaseOrder.buyer_stakeholder.details.company.name">
                  {{ purchaseOrder.buyer_stakeholder.details.company.name}}
                </span>
                <!-- {{ purchaseOrder.buyer_stakeholder.details.user.name}} -->
              </p>
            </div>
            <div class="inv-number">{{ purchaseOrder.purchase_order_number }}</div>
            <div :class="'po-status-'+purchaseOrder.status.toLowerCase()" class="inv-status">{{ purchaseOrder.status }}</div>
          </div>
          <div class="right">
            <div class="inv-amount" v-html="$utils.formatMoney(purchaseOrder.total, purchaseOrder.supplier.account.currency)" />
            <div class="inv-date">{{ purchaseOrder.formattedPurchaseOrderDate }}</div>
          </div>
        </a>
        <p v-if="!purchaseOrders.length" class="no-result">
          {{ $t('pos.no_matching_po') }}
        </p>
      </div>
    </div>
    <div class="po-view-page-container">
      <iframe :src="`${shareableLink}`" class="frame-style"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
const _ = require('lodash')

export default {
  data () {
    return {
      id: null,
      count: null,
      purchaseOrders: [],
      purchaseOrder: null,
      currency: null,
      searchData: {
        orderBy: null,
        orderByField: null,
        searchText: null
      },
      status: ['DRAFT', 'SENT', 'VIEWED', 'EXPIRED', 'ACCEPTED', 'REJECTED','SETTLED'],
      isMarkAsSent: false,
      isSendingEmail: false,
      isRequestOnGoing: false,
      isSearching: false,
      userType:null
    }
  },
  computed: {
    getOrderBy () {
      if (this.searchData.orderBy === 'asc' || this.searchData.orderBy == null) {
        return true
      }
      return false
    },
    getOrderName () {
      if (this.getOrderBy) {
        return this.$t('general.ascending')
      }
      return this.$t('general.descending')
    },
    shareableLink () {
      return `/purchaseOrders/pdf/${this.purchaseOrder.unique_hash}`
    }
  },
  watch: {
    $route (to, from) {
      this.loadPurchaseOrder()
    }
  },
  created () {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor';
    }
    else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder';
    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';
    }
    this.loadPurchaseOrders()
    this.loadPurchaseOrder()
    this.onSearched = _.debounce(this.onSearched, 500)
  },
  methods: {
     ...mapActions('po', [
      'fetchPOs',
      'getRecord',
      'searchPO',
      'markAsSent',
      'sendEmail',
      'deletePO',
      'selectPO',
      'fetchViewPO'
    ]),
    async loadPurchaseOrders () {
        let response = await this.fetchPOs()

        if (response.data) {
            this.purchaseOrders = response.data.purchaseOrders.data
        }
    },
    async loadPurchaseOrder () {
      let response = await this.fetchViewPO(this.$route.params.id)

      if (response.data) {
        this.purchaseOrder = response.data.purchaseOrder
      }
    },
    async onSearched () {
      let data = ''
      data+=`status=SENT&`
      if (this.searchData.searchText !== '' && this.searchData.searchText !== null && this.searchData.searchText !== undefined) {
        data += `search=${this.searchData.searchText}&`
      }

      if (this.searchData.orderBy !== null && this.searchData.orderBy !== undefined) {
        data += `orderBy=${this.searchData.orderBy}&`
      }

      if (this.searchData.orderByField !== null && this.searchData.orderByField !== undefined) {
        data += `orderByField=${this.searchData.orderByField}`
      }

      this.isSearching = true
      let response = await this.searchPO(data)
      this.isSearching = false
      if (response.data) {
        this.purchaseOrders = response.data.purchaseOrders.data
      }
    },
    sortData () {
      if (this.searchData.orderBy === 'asc') {
        this.searchData.orderBy = 'desc'
        this.onSearched()
        return true
      }
      this.searchData.orderBy = 'asc'
      this.onSearched()
      return true
    },
    async onMarkAsSent () {
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('pos.confirm_mark_as_sent'),
        icon: '/assets/icon/check-circle-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          this.isMarkAsSent = true
          let response = await this.markAsSent({id: this.purchaseOrder.id})
          this.isMarkAsSent = false
          if (response.data) {
            window.toastr['success'](this.$tc('pos.mark_as_sent_successfully'))
            this.$router.push('/anchor/purchase-orders')
          }
        }
      })
    },
    async onSendPurchaseOrder (id) {
      window.swal({
        title: this.$t('general.are_you_sure'),
        text: this.$t('pos.confirm_send_po'),
        icon: '/assets/icon/paper-plane-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          this.isSendingEmail = true
          let response = await this.sendEmail({purchase_order_id: this.purchaseOrder.id})
          this.isSendingEmail = false
          if (response.data.success) {
            window.toastr['success'](this.$tc('pos.send_po_successfully'))
            this.$router.push('/anchor/purchase-orders')
            return true
          }
          if (response.data.error === 'user_email_does_not_exist') {
            window.toastr['error'](this.$tc('pos.user_email_does_not_exist'))
            return true
          }
          window.toastr['error'](this.$tc('pos.something_went_wrong'))
        }
      })
    },
    async removePurchaseOrder (id) {
      window.swal({
        title: 'Deleted',
        text: 'you will not be able to recover this Purchase Order!',
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (value) => {
        if (value) {
          let request = await this.deletePO(id)
          if (request.data.success) {
            window.toastr['success'](this.$tc('pos.deleted_message', 1))
            this.$router.push('/anchor/purchase-orders')
          } else if (request.data.error) {
            window.toastr['error'](request.data.message)
          }
        }
      })
    },
    viewPurchaseOrder(id){
      if(this.userType=='anchor'){
        this.$router.push(`/anchor/purchase-orders/${id}/view`)
      }else if(this.userType=='supplier'){
        this.$router.push(`/supplier/purchase-orders/${id}/view`)
      }
    }
  }
}
</script>
